export default {
  state: {
    questionFontSize: 1.5,
    answerFontSize: 0.8
  },
  mutations: {
    SET_QUESTION_FONT_SIZE(state, size) {
      state.questionFontSize = size
      // Salva in localStorage per persistenza
      localStorage.setItem('questionFontSize', size)
    },
    SET_ANSWER_FONT_SIZE(state, size) {
      state.answerFontSize = size
      // Salva in localStorage per persistenza
      localStorage.setItem('answerFontSize', size)
    }
  },
  actions: {
    initFontSize({ commit }) {
      const saved = localStorage.getItem('questionFontSize')

      if (saved) {
        commit('SET_QUESTION_FONT_SIZE', parseFloat(saved))
      }
      const savedAnswer = localStorage.getItem('answerFontSize')
      if (savedAnswer) {
        commit('SET_ANSWER_FONT_SIZE', parseFloat(savedAnswer))
      }
    },
    increaseFonts({ commit, state }) {
      commit('SET_QUESTION_FONT_SIZE', Math.min(state.questionFontSize + 0.2, 3))
      commit('SET_ANSWER_FONT_SIZE', Math.min(state.answerFontSize + 0.2, 2.0))
    },
    decreaseFonts({ commit, state }) {
      commit('SET_QUESTION_FONT_SIZE', Math.max(state.questionFontSize - 0.2, 1.0))
      commit('SET_ANSWER_FONT_SIZE', Math.max(state.answerFontSize - 0.2, 0.6))
    },
    resetFonts({ commit }) {
      commit('SET_QUESTION_FONT_SIZE', 1.5)
      commit('SET_ANSWER_FONT_SIZE', 0.8)
    }
  },
  getters: {
    questionFontSize: state => state.questionFontSize,
    answerFontSize: state => state.answerFontSize
  }
}